export const NON_NUMBER_REGEX = /\D/g;

export const WHITESPACE_REGEX = /\s/g;

export const CALLBACK_DISABLED_MESSAGE = "Call-back function is temporarily unavailable due to high demand.";